export default {
  buttons: {
    go_to_basket: 'Voir le panier',
  },
};
